export const getLogoData = (data) => {
  return {
    src: data.logo || ``,
    title: data.logo_alt || ``,
  };
};
